import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { ChildAgePickerComponentProps } from "./ChildAgePicker";

export const useChildAgePicker = (props: ChildAgePickerComponentProps) => {
  const { t } = useI18nContext();
  const { onAgeSelectHandler, childAge, label } = props;

  const MAX_CHILD_AGE = 17;
  const ageOptions = useMemo(() => {
    return [
      {
        key: "0",
        value: "0",
        label: t("core-hotels.search.guestPicker.child.underOneAge"),
      },
      ...Array.from({ length: MAX_CHILD_AGE }).map((_, i) => {
        const val = `${i + 1}`;
        return {
          key: val,
          value: val,
          label: val,
        };
      }),
    ];
  }, [t]);

  return {
    context: {
      ageOptions,
      childAge,
      childAgeString: childAge != null ? `${childAge}` : "",
    },
    handlers: { onAgeSelectHandler },
    text: {
      childIndexLabel: label,
      selectPlaceholder: t(
        "core-hotels.search.guestPicker.child.selectPlaceHolder"
      ),
      dialogTitle: t("core-hotels.search.guestPicker.child.ageDialog.title"),
      dialogDone: t(
        "core-hotels.search.guestPicker.child.ageDialog.applyButton"
      ),
      dialogTriggerLabel:
        childAge != null
          ? childAge === 0
            ? t("core-hotels.search.guestPicker.child.underOneAge")
            : childAge
          : t("core-hotels.search.guestPicker.child.selectPlaceHolder"),
    },
  };
};
